import { render, staticRenderFns } from "./morePaymentMethodsModal.vue?vue&type=template&id=2f8dc191&scoped=true&"
import script from "./morePaymentMethodsModal.vue?vue&type=script&lang=js&"
export * from "./morePaymentMethodsModal.vue?vue&type=script&lang=js&"
import style0 from "./morePaymentMethodsModal.vue?vue&type=style&index=0&id=2f8dc191&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8dc191",
  null
  
)

export default component.exports